import { useAuthorization } from '@autone/auth';
import { useAutoneTranslation } from '@autone/translations';
import { SwitchRoot, SwitchThumb } from '@autone/ui-next/atoms';
import { AutoneIcon } from '@autone/ui-next/icons';
import { cn } from '@autone/ui-next/utils';
import { AnimatePresence, motion } from 'motion/react';
import { type FC } from 'react';

import { type APP_NAME } from '../../../consts';

interface AssortmentSwitchProps {
  isAssorted?: boolean;
  isAutopilot?: boolean;
  isDisabled?: boolean;
  onChange: (isAssorted: boolean) => void;
}

export const AssortmentSwitch: FC<AssortmentSwitchProps> = ({
  isAssorted,
  isAutopilot,
  isDisabled,
  onChange,
}) => {
  const { t } = useAutoneTranslation<typeof APP_NAME>();
  const { hasReadOnlyAccess } = useAuthorization();

  return (
    <div className="flex flex-row gap-4 items-center">
      <SwitchRoot
        checked={isAssorted}
        onCheckedChange={onChange}
        size="lg"
        disabled={isDisabled || hasReadOnlyAccess}
      >
        <SwitchThumb size="lg">
          <AnimatePresence initial={false} mode="wait">
            {isAutopilot ? (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.2, ease: 'easeInOut' }}
              >
                <AutoneIcon
                  size={'4xs'}
                  className={cn(
                    'absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2',
                    isAssorted ? 'text-primary' : 'text-muted-foreground',
                  )}
                />
              </motion.div>
            ) : null}
          </AnimatePresence>
        </SwitchThumb>
      </SwitchRoot>
      <AnimatePresence>
        {isAutopilot && (
          <motion.p
            exit={{ opacity: 0 }}
            key={'managed-by-autone-text'}
            className="text-sm leading-none"
          >
            {t('assortment-statuses.managed-by-autone')}
          </motion.p>
        )}
      </AnimatePresence>
    </div>
  );
};
